import { Box, Skeleton, Typography } from "@mui/material";

import RightLeftChecker from "./../../../../utils/RightLeftChecker";

const AboutTitle = ({ about }) => {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        backgroundColor: "white.main",
        zIndex: 4,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Tahrir",
          fontSize: "28px",
          lineHeight: "32px",
          marginBottom: "12px",
          fontWeight: 700,
          borderBottom: "2px solid",
          pb: "16px",
          pt: "16px",
          direction: RightLeftChecker(about?.description) ? "rtl" : "ltr",
        }}
      >
        {about?.title}
        {!about && <Skeleton width='60%' height={33} />}
      </Typography>
    </Box>
  );
};
export default AboutTitle;
